export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            联系我们
          </span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading mb-4">
            影视合作与投稿
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-10 max-w-xl mx-auto">
            蓝莓影院欢迎影视制作方、独立导演和内容创作者与我们建立合作关系。
            无论你是希望影片入驻片库，还是有影评投稿需求，我们都期待与你交流。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-send-line text-xl text-primary-600"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1.5">商务合作</h3>
              <p className="text-xs text-foreground-500">partner@lanmeicinema.com</p>
            </div>

            <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-movie-line text-xl text-accent-600"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1.5">影片入驻</h3>
              <p className="text-xs text-foreground-500">content@lanmeicinema.com</p>
            </div>

            <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
              <div className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-edit-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1.5">影评投稿</h3>
              <p className="text-xs text-foreground-500">review@lanmeicinema.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}